import { slice } from './slice'

const afaCartNotificationsSliceActions = {
  ...slice.actions,
}

export default afaCartNotificationsSliceActions
